.popover {
  display: flex;
  flex-direction: column;
  padding: 0 4px;
}
